/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const analyticsFunnelDataSchema = z.object({
	views: z.number(),
	clicks: z.number(),
	candidates: z.number(),
})

export type AnalyticsFunnelDataSchema = z.infer<typeof analyticsFunnelDataSchema>
